<template>
  <el-select :class="{border_none:borderNone}" filterable v-model="id" placeholder="选择税目" size="mini">
    <el-option
      v-for="item in options"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>
<script>
export default {
  props:{
    taxId: {
      type: Number,
      default: 0
    },
    borderNone:{
      type:Boolean,
      default:false
    }
  },
  computed: {
    options(){
      return this.$store.getters["commons/taxCategorys"]
    },
    id: {
      get() {
        if(!this.taxId){
          return ""
        }
        return this.taxId
      },
      set(val) {
        this.$emit("update:taxId", val)
        let info = {}
        this.options.map(v=>{
          if(v.id == val){
            info = v
          }
        })
        this.$emit("update:taxRate", info.rate)
        this.$emit("success", val)
      }
    }
  },
}
</script>